import Sentry from './sentry.service'
import { getProductName } from '@dg-util'

// v7's startTransaction() + getCurrentHub().configureScope(setSpan) is gone — a transaction is now
// just a root span. forceTransaction keeps it reported as one rather than a standalone span, and
// child spans reach it explicitly via `parentSpan` (see apiV2.service.ts) rather than an active-scope lookup.
export const getSentryPerformanceTransaction = (name: string) => {
  const productName = getProductName()
  return Sentry.startInactiveSpan({
    name: `${name} [${PARTNER_NAME}][${productName}]`,
    forceTransaction: true,
  })
}
